import React from 'react';
import { CloudImage } from '@components/CloudImage';
import { HowWeWorkContent } from './HowWeWorkContent';
import { WrapperBox, BottomBackground, MobileBottomForeground } from './HowWeWork.styles';

export const HowWeWorkMobile: React.FC = () => {
  return (
    <WrapperBox paddingTop={11} paddingBottom={14}>
      <HowWeWorkContent />
      <BottomBackground>
        <CloudImage src={'careers/how-we-work/bg-bottom-left-v2.png'} width="100%" />
      </BottomBackground>
      <MobileBottomForeground>
        <CloudImage src={'careers/how-we-work/fg-left-art.svg'} width="100%" />
      </MobileBottomForeground>
    </WrapperBox>
  );
};
